import { NgKLoggerService } from '@kin/ngk-logger';

import { LegacyApiPagesComponent } from 'app/home/common/services/legacy/quote-pages';
import { LegacyApiPagesRentalStatusComponent } from 'app/home/create-quote/forms/rental-status/rental-status.types';

const LEGACY_PAGES_API_RENTAL_STATUS_OPTIONS_VALUES = [0, null];

export function getOptionsForLegacyPagesApiRentalStatusComponent(components: LegacyApiPagesComponent[], logger: NgKLoggerService): undefined {
  const rentalStatusComponent = components.find((component) => component.attribute_name === 'times_rented');
  if (!rentalStatusComponent) {
    logger.error({ message: 'could not find component for times_rented', context: 'getOptionsForLegacyPagesApiRentalStatusComponent', priority: 'P3' });
    return;
  }

  const optionsValues = (rentalStatusComponent as unknown as LegacyApiPagesRentalStatusComponent).select_options.map((option) => {
    return option.value;
  });

  if (optionsValues.some((option) => !LEGACY_PAGES_API_RENTAL_STATUS_OPTIONS_VALUES.includes(option))) {
    logger.error({ message: 'unexpected value found in dot-com select_options for times_rented component', context: 'getOptionsForLegacyPagesApiRentalStatusComponent', priority: 'P3' });
  }
}
